import ChartAPI from "../../apps/common/chart-api";
import {mapActions} from "vuex";

// Yandex.Metrika counter
(function (m, e, t, r, i, k, a) {
  m[i] =
    m[i] ||
    function () {
      (m[i].a = m[i].a || []).push(arguments);
    };
  m[i].l = 1 * new Date();
  for (var j = 0; j < document.scripts.length; j++) {
    if (document.scripts[j].src === r) {
      return;
    }
  }
  (k = e.createElement(t)),
    (a = e.getElementsByTagName(t)[0]),
    (k.async = 1),
    (k.src = r),
    a.parentNode.insertBefore(k, a);
})(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
ym(91126829, "init", {
  clickmap: true,
  trackLinks: true,
  accurateTrackBounce: true,
  webvisor: true,
});

// formatting date for comparing mode ("\\d{2}.\\d{2}\\s+-\\s+\\d{2}.\\d{2}.\\d{4}")
function formatDateString(inputString) {
  let parts = inputString.split(" - ");
  let datePart = parts[0].split(".");
  let formattedDatePart = datePart[0] + "." + datePart[1];

  return formattedDatePart + " - " + parts[1];
}

// Функция для нормализации радиуса пузырька по SOV
function sovToRadius(sov, minRadius = 10, maxRadius = 45) {
    // Обеспечиваем минимальный радиус для ProjectAdvertiser
    if (sov < 0.01) {
        return minRadius; // Минимальный радиус для очень маленьких SOV
    }
    sov = Math.max(0.01, Math.min(1, sov));
    return minRadius + (maxRadius - minRadius) * ((sov - 0.01) / (1 - 0.01));
}

export default {
    namespaced: true,
    state: {
        reports: [],
        loading: false,
        isCorrectPeriod: true,
        // Индивидуальные лоадеры для каждого графика
        individualLoaders: {},
    },
    actions: {
        ...mapActions("chart_utils", ["getRandomColor"]),

        async fetchSovReports({commit, dispatch, rootGetters, getters}) {
            if (rootGetters["currentProjectId"] == null) {
                return;
            }
            let studObj = new ChartAPI();
            commit("updateLoading", true);
            commit("resetIndividualLoaders"); // Сбрасываем все индивидуальные лоадеры
            commit("updateReports", []);
            let slice = rootGetters["filters/slice"];
            if (slice) {
                slice = slice["value"];
                if (slice === "src") {
                    commit("filters/updateSearchEngines", rootGetters["filters/optionsSearchEngines"]);
                    localStorage.removeItem('searchEngines');
                    localStorage.setItem('searchEngines', JSON.stringify(rootGetters["filters/optionsSearchEngines"]));
                } else if (slice === "dsl") {
                    commit("filters/updateDeviceTypes", rootGetters["filters/optionsDeviceTypes"]);
                    localStorage.removeItem('deviceTypes');
                    localStorage.setItem('deviceTypes', JSON.stringify(rootGetters["filters/optionsDeviceTypes"]));
                } else if (slice === "kwt") {
                    commit("filters/updateKeywordsTypes", rootGetters["filters/keywordsTypes"]);
                    localStorage.removeItem('keywordsTypes');
                    localStorage.setItem('keywordsTypes', JSON.stringify(rootGetters["filters/keywordsTypes"]));
                } else if (slice === "ggr") {
                    commit("filters/updateGeoLocations", rootGetters["filters/geoLocations"]);
                    localStorage.removeItem('geolocation');
                    localStorage.setItem('geolocation', JSON.stringify(rootGetters["filters/geoLocations"]));
                } else if (slice === "clt") {
                    // Для среза по времени сбора сбросы не требуются
                } else throw new TypeError("Unknown slice type");
            }

            let id_cnt = 0;
            for (let params of getters["reportBaseData"]) {
                params.id = id_cnt;
                params.loaded = false;
                params.response = [];
                params.responseDynamic = [];
                params.response_comparing = [];
                params.response_comparingDynamic = [];
                commit("pushReport", params);
                id_cnt++;
                let dynamic_params = params.query;
                if (params.query_comparing) {
                    dynamic_params = dynamic_params + '&' + rootGetters["filters/dynamicDashboardParams"]
                }

                // Устанавливаем лоадер для конкретного отчета
                const bubbleLoaderType = `bubbleChart_${params.id}`;
                commit("setIndividualLoader", { loaderType: bubbleLoaderType, loading: true });

                let jsonOurResponse = await studObj.sendRequest(
                    "getPivotChart",
                    rootGetters["currentProjectId"],
                    dynamic_params
                );

                // Отключаем лоадер конкретного отчета сразу после получения данных
                commit("setIndividualLoader", { loaderType: bubbleLoaderType, loading: false });

                if (jsonOurResponse != undefined && jsonOurResponse.length) {
                    params.response = jsonOurResponse;
                }
                else {
                    params.response = [];
                }

                // Устанавливаем лоадеры для динамических графиков конкретного отчета
                const dynamicMeanPositionLoaderType = `dynamicMeanPosition_${params.id}`;
                const dynamicSOVLoaderType = `dynamicSOV_${params.id}`;
                commit("setIndividualLoader", { loaderType: dynamicMeanPositionLoaderType, loading: true });
                commit("setIndividualLoader", { loaderType: dynamicSOVLoaderType, loading: true });

                let jsonOurDynamicResponse = await studObj.sendRequest(
                    "getDynamicSOV",
                    rootGetters["currentProjectId"],
                    dynamic_params
                );

                // Отключаем лоадеры динамических графиков конкретного отчета сразу после получения данных
                commit("setIndividualLoader", { loaderType: dynamicMeanPositionLoaderType, loading: false });
                commit("setIndividualLoader", { loaderType: dynamicSOVLoaderType, loading: false });

                if (jsonOurDynamicResponse != undefined && jsonOurDynamicResponse.length) {
                    params.responseDynamic = jsonOurDynamicResponse;
                }
                else {
                    params.responseDynamic = [];
                }

                // do second request for reports with date comparing
                if (params.query_comparing) {
                    let second_data = [];
                    const chartData = (jsonOurResponse && Array.isArray(jsonOurResponse)) ? jsonOurResponse : [];

                    for (var i = 0; i < chartData.length; i++){
                        let el = chartData[i];
                        if (el.advertiser_title_other) {
                            let new_el = {
                                mean_position: el.mean_position_other,
                                sov: el.sov_other,
                                special_share: el.special_share_other,
                                inaccuracy_position: el.inaccuracy_position_other,
                                advertiser_id: el.advertiser_id,
                                is_project: el.is_project,
                                advertiser_title: el.advertiser_title,
                                sov_diff: el.sov_diff,
                                mean_position_diff: el.mean_position_diff,
                                special_share_diff: el.special_share_diff,
                                pct_in_title: el.pct_in_title_other,
                                pct_in_content: el.pct_in_content_other,
                                pct_in_title_diff: el.pct_in_title_diff,
                                pct_in_content_diff: el.pct_in_content_diff,
                                rank: el.rank
                            }
                            second_data.push(new_el);
                        }

                    }
//          let jsonOurDynamicResponse = await studObj.sendRequest(
//              "getDynamicSOV",
//              rootGetters["currentProjectId"],
//              params.query_comparing
//          );
                    if (second_data.length) {
                        params.response_comparing = second_data;
                    }
                }
                params.loaded = true;
                dispatch("processReport", params);
                dispatch("processDynamicReport", params);
            }
            commit("updateLoading", false);
        },

        async processReport({commit, dispatch, rootGetters, getters}, report) {
            report.items = []; // items for table
            report.labels = []; // items for table
            report.chartBubbleData = {
                labels: [report.date],
                datasets: [],
            };
            report.chartLineDataDynamicSOV = {
                labels: [report.date],
                datasets: [],
            }
            report.chartLineDataDynamicMeanPosition = {
                labels: [report.date],
                datasets: [],
            }
            report.chartLineDataDynamicSpecialShare = {
                labels: [report.date],
                datasets: [],
            }
            report.chartLineDataDynamicPctInTitle = {
                labels: [report.date],
                datasets: [],
            }
            report.chartLineDataDynamicPctInContent = {
                labels: [report.date],
                datasets: [],
            }
            // reports title
            if (report.slice_param) {
                report.title = `Сравнение конкурентов ТОП-15 по ${report.slice_param
                    .charAt(0)
                    .toUpperCase()}${report.slice_param.slice(1)}`;
                report.titleDynamicSOV = `Динамика SOV по ${report.slice_param
                    .charAt(0)
                    .toUpperCase()}${report.slice_param.slice(1)}`;
                report.titleDynamicMeanPosition = `Динамика средней позиции по ${report.slice_param
                    .charAt(0)
                    .toUpperCase()}${report.slice_param.slice(1)}`;
            } else {
                report.title = "Сравнение конкурентов ТОП-15";
                report.titleDynamicSOV = "Динамика SOV";
                report.titleDynamicMeanPosition = "Динамика средней позиции";
            }

            if (report.response && report.response.length || (report.response_comparing && report.response_comparing.length)) {
                let xAxisNumberGlobal = 0;
                
                // parse response and fill data to report object
                if (report.response && report.response.length) {
                    // Находим ProjectAdvertiser в полном списке основного периода
                    let projectAdvertiser = report.response.find(element => element.is_project === true);
                    
                    // Берем топ-15, но принудительно включаем ProjectAdvertiser на последнее место, если он не в топе
                    let top15 = report.response.slice(0, 15);
                    if (projectAdvertiser && !top15.find(el => el.is_project === true)) {
                        top15[14] = projectAdvertiser;
                    }
                    // Если включён сравнительный период: рекламодатель проекта может быть только там — тоже ставим на 15-е место
                    if (report.response_comparing && report.response_comparing.length) {
                        let projectAdvertiserComparing = report.response_comparing.find(element => element.is_project === true);
                        if (projectAdvertiserComparing && !top15.find(el => el && el.is_project === true)) {
                            top15[14] = { ...projectAdvertiserComparing, has_main_period_data: false };
                        }
                    }
                    
                    // Только топ-15 (рекламодатель проекта всегда на последнем месте, если есть в основном или сравнительном периоде)
                    let mainPeriodAdvertisers = top15.map(element => element && element.advertiser_title).filter(title => title);
                    let allAdvertisers = mainPeriodAdvertisers;
                    
                    // Создаем datasets для каждого рекламодателя (ПОСЛЕ обновления allAdvertisers)
                    allAdvertisers.forEach((advertiserTitle, idx) => {
                        // Определяем цвет в зависимости от того, является ли рекламодатель "нашим"
                        let isOurAdvertiser = false;
                        
                        // Проверяем основной период
                        if (report.response && report.response.length) {
                            for (let element of report.response) {
                                if (element && element.advertiser_title === advertiserTitle && element.is_project) {
                                    isOurAdvertiser = true;
                                    break;
                                }
                            }
                        }
                        
                        // Проверяем сравнительный период (если не нашли в основном)
                        if (!isOurAdvertiser && report.response_comparing && report.response_comparing.length) {
                            for (let element of report.response_comparing) {
                                if (element && element.advertiser_title === advertiserTitle && element.is_project) {
                                    isOurAdvertiser = true;
                                    break;
                                }
                            }
                        }
                        
                        // Основной период - синий цвет
                        let backgroundColor = isOurAdvertiser ? 
                            "rgba(61, 70, 161, 0.9)" : "rgba(61, 70, 161, 0.5)";
                        let borderColor = isOurAdvertiser ? 
                            "rgba(61, 70, 161, 1.0)" : "rgba(61, 70, 161, 0.5)";
                        let borderWidth = isOurAdvertiser ? 2 : 1;
                        
                        report.chartBubbleData.datasets.push({
                            label: advertiserTitle,
                            backgroundColor: backgroundColor,
                            pointBackgroundColor: "white",
                            borderWidth: borderWidth,
                            pointBorderColor: borderColor,
                            data: [],
                        });
                        
                        // Сравнительный период - оранжевый цвет (если есть сравнительный период)
                        if (report.response_comparing && report.response_comparing.length) {
                            let comparingBackgroundColor = isOurAdvertiser ? 
                                "rgba(255, 55, 18, 0.9)" : "rgba(255, 55, 18, 0.5)";
                            let comparingBorderColor = isOurAdvertiser ? 
                                "rgba(255, 55, 18, 1.0)" : "rgba(255, 55, 18, 0.5)";
                            let comparingBorderWidth = isOurAdvertiser ? 2 : 1;
                            
                            report.chartBubbleData.datasets.push({
                                label: advertiserTitle + " (сравнение)",
                                backgroundColor: comparingBackgroundColor,
                                pointBackgroundColor: "white",
                                borderWidth: comparingBorderWidth,
                                pointBorderColor: comparingBorderColor,
                                data: [],
                            });
                        }
                    });
                    
                    for (let element of top15) {
                        if (!element || !element.advertiser_title) continue;
                        
                        xAxisNumberGlobal += 1;
                        report.labels.push(element["advertiser_title"]);

                        // Находим соответствующий dataset для этого рекламодателя
                        let datasetIndex = report.chartBubbleData.datasets.findIndex(dataset => 
                            dataset.label === element["advertiser_title"]
                        );
                        
                        if (datasetIndex !== -1) {
                            // В график основной период не передаём, если данных за основной период не было (нули подставлены для таблицы)
                            const hasMainPeriodData = element["has_main_period_data"] !== false;
                            if (hasMainPeriodData) {
                                let radius = sovToRadius(element["sov"]);
                                report.chartBubbleData.datasets[datasetIndex].data.push({
                                    x: xAxisNumberGlobal,
                                    y: element["mean_position"],
                                    r: radius,
                                    sov: element["sov"],
                                    special_share: element["special_share"],
                                    advertiser_title: element["advertiser_title"],
                                    inaccuracy_position: element["inaccuracy_position"],
                                    rank: element["rank"],
                                    is_project: element["is_project"] || false,
                                });
                            }
                        }

                        // items for table (порядок: Рекламодатель, SOV, Средняя позиция, Доля премиум-показов, Вхождение в заголовок, Вхождение в текст)
                        let item = {
                            advertiser_id: element["advertiser_id"],
                            advertiser: element["advertiser_title"],
                            meanPosition: parseFloat(
                                element["mean_position"]
                            ).toFixed(2),
                            mathInaccuracy: parseFloat(
                                element["inaccuracy_position"]
                            ).toFixed(2),
                            sov: `${(parseFloat(element["sov"]) * 100).toFixed(
                                0
                            )}%`,
                            special_share: `${(parseFloat(element["special_share"]) * 100).toFixed(
                                0
                            )}%`,
                            pct_in_title: element["pct_in_title"] != null ? `${Math.round(Number(element["pct_in_title"]))}%` : "-",
                            pct_in_content: element["pct_in_content"] != null ? `${Math.round(Number(element["pct_in_content"]))}%` : "-",
                        };

                        // data for comparing mode
                        if (report.response_comparing && report.response_comparing.length) {
                            let datasetComparingFound = report.response_comparing.slice(0, 15).find(e => e && e.advertiser_title === element.advertiser_title);
                                if (datasetComparingFound) {
                                // Находим соответствующий dataset для сравнительного периода
                                let comparingDatasetIndex = report.chartBubbleData.datasets.findIndex(dataset => 
                                    dataset.label === element["advertiser_title"] + " (сравнение)"
                                );
                                
                                // Добавляем данные в сравнительный период
                                if (comparingDatasetIndex !== -1) {
                                    report.chartBubbleData.datasets[comparingDatasetIndex].data.push({
                                        x: xAxisNumberGlobal,
                                        y: datasetComparingFound["mean_position"],
                                        r: sovToRadius(datasetComparingFound["sov"]),
                                        sov: datasetComparingFound["sov"],
                                        special_share: element["special_share"],
                                        advertiser_title: datasetComparingFound["advertiser_title"],
                                        inaccuracy_position: datasetComparingFound["inaccuracy_position"],
                                        rank: datasetComparingFound["rank"],
                                        is_project: datasetComparingFound["is_project"] || false,
                                    });
                                }

                                item.itemsmeanPositionAnother = parseFloat(
                                    datasetComparingFound["mean_position"]
                                ).toFixed(1);
                                item.mathInaccuracyAnother = parseFloat(
                                    datasetComparingFound["inaccuracy_position"]
                                ).toFixed(2);
                                item.sovAnother = `${(
                                    parseFloat(datasetComparingFound["sov"]) * 100
                                ).toFixed(0)}%`;
                            }
                        }
                        report.items.push(item);
                    }
                }

                // reports title
                if (report.slice_param) {
                    report.title = `Топ-${xAxisNumberGlobal} рекламодателей по SOV по ${report.slice_param
                        .charAt(0)
                        .toUpperCase()}${report.slice_param.slice(1)}`;
                } else {
                    report.title = `Топ-${xAxisNumberGlobal} рекламодателей по SOV`;
                }
            }
            report.loaded = true;
            commit("updateReport", report);
        },

        updateIsCorrectPeriod ({commit}, value) {
            commit("updateIsCorrectPeriod", value);
        },

        async processDynamicReport({commit, dispatch, rootGetters, getters}, report) {
            if (report.responseDynamic || report.response_comparingDynamic) {
                let coloursRandomColorDynamic = {
                    0: "rgba(59, 44, 221, 1)",
                    1: "rgba(255, 55, 18, 1)",
                    2: "rgba(255, 140, 18, 1)",
                    3: "rgba(13, 187, 72, 1)",
                    4: "rgba(17, 124, 159, 1)",
                    5: "rgba(87,86,86, 1)",
                    6: "rgba(175, 221, 44, 1)",
                    7: "rgba(255, 18, 217, 1)",
                    8: "rgba(18, 70, 255, 1)",
                    9: "rgba(187, 13, 13, 1)",
                    10: "rgba(20, 159, 17, 1)",
                    11: "rgba(23, 218, 239, 1)"
                }
                let dateDifferenceStep = 1;
                const hoursDate = 1000 * 60 * 60 * 24;
                const monthDaysNumber = 28;
                try {
                    // cюда подставить метод вызова API
                    // let apiResponse = await require('./newData.json')
                    let apiResponse = report.responseDynamic;
                    report.itemsDynamic = [];
                    if (apiResponse && (apiResponse.length !== 0)) {
                        let startDateString = report.date.split("-")[0].replaceAll(" ", "").split(".").reverse();
                        var startDate = new Date(startDateString[0], startDateString[1] - 1, startDateString[2]);
                        let endDateString = report.date.split("-")[1].replaceAll(" ", "").split(".").reverse();
                        var endDate = new Date(endDateString[0], endDateString[1] - 1, endDateString[2]);
                        if ((Math.abs((endDate - startDate) / hoursDate)) >= monthDaysNumber) {
                            dateDifferenceStep = 7;
                        }
                    }
                    if ((report.response_comparingDynamic) && (report.response_comparingDynamic.length !== 0)) {  // Comparing continuity
                        // ПАТЧ: всегда объединяем оба массива, даже если периоды разные!
                        apiResponse = (apiResponse || []).concat(report.response_comparingDynamic);
                        // Сортируем по дате
                        apiResponse.sort((p1, p2) => (new Date(p1.date) < new Date(p2.date)) ? -1 : (new Date(p1.date) > new Date(p2.date)) ? 1 : 0);
                    }
                    if (apiResponse && (apiResponse.length !== 0)) {
                        commit("updateIsCorrectPeriod", true);
                        // Новый блок: формируем все уникальные даты из обоих периодов
                        let allUniqueDates = [...new Set(apiResponse.map(a => a.date))].sort((a, b) => new Date(a) - new Date(b));
                        
                        // Определяем диапазон дат для выбора стратегии группировки
                        const dateRangeDays = (new Date(allUniqueDates[allUniqueDates.length - 1]) - new Date(allUniqueDates[0])) / (1000 * 60 * 60 * 24);
                        
                        let allDates = allUniqueDates;
                        
                        if (dateRangeDays <= 7) {
                            // Диапазон до 7 дней включительно — показываем все даты
                            allDates = allUniqueDates;
                        } else if (dateRangeDays <= 21) {
                            // Диапазон 8 - 21 дней — отображаем даты с шагом раз в 2 дня
                            allDates = [];
                            for (let i = 0; i < allUniqueDates.length; i += 2) {
                                allDates.push(allUniqueDates[i]);
                            }
                            
                            // ВСЕГДА добавляем последнюю дату, если её нет
                            const lastDate = allUniqueDates[allUniqueDates.length - 1];
                            if (!allDates.includes(lastDate)) {
                                allDates.push(lastDate);
                            }
                            
                            // Сортируем финальный массив
                            allDates.sort((a, b) => new Date(a) - new Date(b));
                        } else {
                            // Диапазон 21 день и более — отображаем даты с шагом раз в 4 дня
                            allDates = [];
                            for (let i = 0; i < allUniqueDates.length; i += 4) {
                                allDates.push(allUniqueDates[i]);
                            }
                            
                            // ВСЕГДА добавляем последнюю дату, если её нет
                            const lastDate = allUniqueDates[allUniqueDates.length - 1];
                            if (!allDates.includes(lastDate)) {
                                allDates.push(lastDate);
                            }
                            
                            // Сортируем финальный массив
                            allDates.sort((a, b) => new Date(a) - new Date(b));
                        }
                        
                        
                        // Определяем топ-12 рекламодателей по количеству точек
                        let advertisersCount = {};
                        for (let a of apiResponse) {
                            advertisersCount[a.advertiser_title] = (advertisersCount[a.advertiser_title] || 0) + 1;
                        }
                        
                        let top12 = Object.entries(advertisersCount)
                            .sort((a, b) => b[1] - a[1])
                            .slice(0, 12)
                            .map(a => a[0]);
                        
                        // ИСПРАВЛЕНИЕ: Принудительно включаем ProjectAdvertiser в топ-12
                        // Получаем информацию о ProjectAdvertiser из динамических данных (apiResponse)
                        let projectAdvertiserTitle = null;
                        if (apiResponse && apiResponse.length > 0) {
                            // Ищем рекламодателя с is_project = true в динамических данных
                            const projectAdvertiser = apiResponse.find(item => item.is_project === true);
                            if (projectAdvertiser) {
                                projectAdvertiserTitle = projectAdvertiser.advertiser_title;
                            }
                        }
                        
                        // Если ProjectAdvertiser найден и не входит в топ-12, добавляем его
                        if (projectAdvertiserTitle && !top12.includes(projectAdvertiserTitle)) {
                            // Удаляем последнего рекламодателя из топ-12 и добавляем ProjectAdvertiser
                            if (top12.length >= 12) {
                                top12.pop();
                            }
                            top12.push(projectAdvertiserTitle);
                        }
                        // Цвета для рекламодателей (фиксированные для первых мест)
                        let coloursRandomColorDynamic = [
                            "rgba(59, 44, 221, 1)",    // ProjectAdvertiser - синий
                            "rgba(255, 55, 18, 1)",    // 1-е место среди остальных - красный
                            "rgba(13, 187, 72, 1)",    // 2-е место среди остальных - зеленый
                            "rgba(128, 0, 128, 1)",   // 3-е место среди остальных - фиолетовый
                            "rgba(17, 124, 159, 1)",  // 4-е место и далее - циклически
                            "rgba(87,86,86, 1)",
                            "rgba(175, 221, 44, 1)",
                            "rgba(18, 70, 255, 1)",
                            "rgba(187, 13, 13, 1)",
                            "rgba(20, 159, 17, 1)",
                            "rgba(23, 218, 239, 1)",
                            "rgba(255, 140, 18, 1)"
                        ];
                        // Подписи оси X графиков динамики: только DD.MM без года
                        report.itemsDynamic = allDates.map(date => date.split('-').reverse().slice(0, 2).join('.'));
                        let gridColor = '#B0B0C3';
                        let labelColor = '#B0B0C3';
                        report.chartLineDataDynamicSOV.labels = report.chartLineDataDynamicMeanPosition.labels = report.itemsDynamic;
                        report.chartLineDataDynamicSOV.datasets = [];
                        report.chartLineDataDynamicMeanPosition.datasets = [];
                        report.chartLineDataDynamicSpecialShare.datasets = [];
                        report.chartLineDataDynamicPctInTitle.datasets = [];
                        report.chartLineDataDynamicPctInContent.datasets = [];

                        // Создаем массив рекламодателей без ProjectAdvertiser для правильного назначения цветов
                        let advertisersWithoutProject = top12.filter(title => title !== projectAdvertiserTitle);
                        
                        top12.forEach((advertiserTitle, idx) => {
                            
                            let dataSOV = [];
                            let dataMeanPosition = [];
                            let dataSpecialShare = [];
                            let dataPctInTitle = [];
                            let dataPctInContent = [];
                            let foundCount = 0;
                            
                            for (let date of allDates) {
                                let found = apiResponse.find(a => a.advertiser_title === advertiserTitle && a.date === date);
                                if (found) {
                                    foundCount++;
                                }
                                dataSOV.push(found ? Math.round((found.sov).toFixed(2) * 100) : null);
                                dataMeanPosition.push(found ? (found.mean_position).toFixed(2) : null);
                                dataSpecialShare.push(found ? Math.round((found.special_share).toFixed(2) * 100) : null);
                                dataPctInTitle.push(found && found.pct_in_title != null ? Math.round(Number(found.pct_in_title)) : null);
                                dataPctInContent.push(found && found.pct_in_content != null ? Math.round(Number(found.pct_in_content)) : null);
                            }
                            
                            // Определяем цвет: ProjectAdvertiser всегда синий, остальные по позиции среди не-ProjectAdvertiser
                            let color;
                            if (advertiserTitle === projectAdvertiserTitle) {
                                color = "rgba(59, 44, 221, 1)"; // ProjectAdvertiser всегда синий
                            } else {
                                // Находим позицию этого рекламодателя среди не-ProjectAdvertiser
                                let positionAmongOthers = advertisersWithoutProject.indexOf(advertiserTitle);
                                
                                // Назначаем цвета по позиции: 0=красный, 1=зеленый, 2=фиолетовый, 3+=циклически
                                if (positionAmongOthers < 3) {
                                    color = coloursRandomColorDynamic[positionAmongOthers + 1]; // +1 потому что 0-й индекс это синий для ProjectAdvertiser
                                } else {
                                    // Для позиций 4+ используем циклические цвета, начиная с 4-го индекса
                                    color = coloursRandomColorDynamic[4 + (positionAmongOthers - 3) % (coloursRandomColorDynamic.length - 4)];
                                }
                            }
                            report.chartLineDataDynamicSOV.datasets.push({
                                data: dataSOV,
                                rank: idx + 1,
                                label: advertiserTitle,
                                fill: false,
                                spanGaps: true,
                                hidden: idx >= 3, // первые 3 видимы, остальные скрыты
                                pointBackgroundColor: color,
                                pointBorderColor: color,
                                pointHoverBorderColor: color,
                                borderColor: color,
                                pointRadius: 3,
                                tension: 0.4,
                                borderWidth: 1.6,
                        });
                        report.chartLineDataDynamicMeanPosition.datasets.push({
                            data: dataMeanPosition,
                            rank: idx + 1,
                            label: advertiserTitle,
                            fill: false,
                            spanGaps: true,
                            hidden: idx >= 3, // первые 3 видимы, остальные скрыты
                            pointBackgroundColor: color,
                            pointBorderColor: color,
                            pointHoverBorderColor: color,
                            borderColor: color,
                            pointRadius: 3,
                            tension: 0.4,
                            borderWidth: 1.6,
                        });
                        report.chartLineDataDynamicSpecialShare.datasets.push({
                            data: dataSpecialShare,
                            rank: idx + 1,
                        });
                        report.chartLineDataDynamicPctInTitle.datasets.push({
                            data: dataPctInTitle,
                            rank: idx + 1,
                        });
                        report.chartLineDataDynamicPctInContent.datasets.push({
                            data: dataPctInContent,
                            rank: idx + 1,
                        });
                    });
                    } else {
                        // commit("updateIsCorrectPeriod", false);
                    }
                    report.loaded = true;
                    commit("updateReport", report);
                } catch (e) {
                    // console.error(e)
                }
            }
        },
    },
    mutations: {
        updateLoading(state, loading) {
            state.loading = loading;
        },
        updateReports(state, reports) {
            state.reports = reports;
        },
        pushReport(state, report) {
            state.reports.push(report);
        },
        updateReport(state, report) {
            const index = state.reports.findIndex((el) => el.id === report.id);
            if (index !== -1) state.reports.splice(index, 1, report);
        },
        updateIsCorrectPeriod(state, correctPeriod) {
            state.isCorrectPeriod = correctPeriod;
        },
        // Мутации для индивидуальных лоадеров
        setIndividualLoader(state, { loaderType, loading }) {
            state.individualLoaders[loaderType] = loading;
        },
        resetIndividualLoaders(state) {
            Object.keys(state.individualLoaders).forEach(key => {
                state.individualLoaders[key] = false;
            });
        },
    },
    getters: {
        reportBaseData(state, getters, rootState, rootGetters) {
            let reportsParams = [];
            let is_comparing = rootGetters["filters/comparingState"];
            let slice = rootGetters["filters/slice"];
            if (slice) {
                slice = slice["value"]
            }

            // splitting query parameters into slices, if necessary
            if (slice === "src") {
                ["yandex", "google"].forEach((elem) => {
                    reportsParams.push({
                        slice_param: elem,
                        query: [
                            `&engine=${elem}` +
                            rootGetters["filters/deviceTypesParam"] +
                            rootGetters["filters/keywordsTypesParam"] +
                            rootGetters["filters/geoLocationsParam"] +
                            rootGetters["filters/keywordsParam"],
                        ],
                    });
                });
            } else if (slice === "dsl") {
                ["true", "false"].forEach((elem) => {
                    reportsParams.push({
                        slice_param: elem === "true" ? "Desktop" : "Mobile",
                        query: [
                            `&is_desktop=${elem}` +
                            rootGetters["filters/searchEngineParam"] +
                            rootGetters["filters/keywordsTypesParam"] +
                            rootGetters["filters/geoLocationsParam"] +
                            rootGetters["filters/keywordsParam"],
                        ],
                    });
                });
            } else if (slice === "kwt") {
                if (rootGetters["filters/keywordsTypes"].length) {
                    rootGetters["filters/keywordsTypes"].forEach((elem) => {
                        reportsParams.push({
                            slice_param: elem["title"],
                            query: [
                                `&kw_type=${elem["value"]}` +
                                rootGetters["filters/searchEngineParam"] +
                                rootGetters["filters/geoLocationsParam"] +
                                rootGetters["filters/deviceTypesParam"] +
                                rootGetters["filters/keywordsParam"],
                            ],
                        });
                    });
                } else {
                    rootGetters["filters/optionsKeywordsTypes"].forEach((elem) => {
                        reportsParams.push({
                            slice_param: elem["title"],
                            query: [
                                `&kw_type=${elem["value"]}` +
                                rootGetters["filters/searchEngineParam"] +
                                rootGetters["filters/geoLocationsParam"] +
                                rootGetters["filters/deviceTypesParam"] +
                                rootGetters["filters/keywordsParam"],
                            ],
                        });
                    });
                }
            } else if (slice === "ggr") {
                rootGetters["filters/optionsGeoLocation"].forEach((elem) => {
                    reportsParams.push({
                        slice_param: elem["name"],
                        query: [
                            `&geolocation_tag=${elem["id"]}` +
                            rootGetters["filters/searchEngineParam"] +
                            rootGetters["filters/keywordsTypesParam"] +
                            rootGetters["filters/deviceTypesParam"] +
                            rootGetters["filters/keywordsParam"],
                        ],
                    });
                });
            } else if (slice === "clt") {
                [
                    { title: "День", value: "day" },
                    { title: "Ночь", value: "night" },
                ].forEach((elem) => {
                    reportsParams.push({
                        slice_param: elem.title,
                        query: [
                            `&collect_time=${elem.value}` +
                            rootGetters["filters/searchEngineParam"] +
                            rootGetters["filters/keywordsTypesParam"] +
                            rootGetters["filters/deviceTypesParam"] +
                            rootGetters["filters/geoLocationsParam"] +
                            rootGetters["filters/keywordsParam"],
                        ],
                    });
                });
            } else {
                reportsParams.push({
                    slice_param: null,
                    query: [
                        rootGetters["filters/geoLocationsParam"] +
                        rootGetters["filters/searchEngineParam"] +
                        rootGetters["filters/keywordsTypesParam"] +
                        rootGetters["filters/deviceTypesParam"] +
                        rootGetters["filters/keywordsParam"],
                    ],
                });
            }
            // add second request with another date for every report if comparing enabled
            reportsParams.forEach((params) => {
                params.query = "?" + rootGetters["filters/dateRangeParam"] + params.query;
                if (is_comparing) {
                    params.query = params.query + "&comparing=true"
                }
                if (slice) {
                    params.query = params.query + "&slicing=true"
                }
                params.date = rootGetters["filters/dateRangeString"].replaceAll(" ", "").replace("-", " - ");
                if (is_comparing) {
                    params.date_comparing = rootGetters["filters/dateRangeComparingString"].replaceAll(" ", "").replace("-", " - ");
                    let queryParams = params.query.replace(`?${rootGetters["filters/dateRangeParam"]}`, "")
                    params.query_comparing = "?" + rootGetters["filters/dateRangeComparingParam"] + queryParams;
                }
            });
            return reportsParams;
        },
        reports(state) {
            return [...new Map(state.reports.map(item => [item["slice_param"], item])).values()];
        },

        report_sections(state) {
            const sections = [];
            for (let report in state.reports) {
                if (!state.reports[report].loaded || !state.reports[report].items.length) continue;
                const sliceName = state.reports[report].slice_param
                    ? state.reports[report].slice_param.charAt(0).toUpperCase() + state.reports[report].slice_param.slice(1)
                    : "";
                let items = state.reports[report].items.map(item => ({ ...item }));
                if (state.reports[report].response_comparing.length) {
                    for (let idx = 0; idx < items.length; idx++) {
                        const found = state.reports[report].response_comparing.find(e => e.advertiser_title === items[idx].advertiser);
                        if (found) {
                            items[idx] = {
                                ...items[idx],
                                mean_position_diff: found.mean_position_diff != null ? found.mean_position_diff : null,
                                sov_diff: found.sov_diff != null ? found.sov_diff : null,
                                special_share_diff: found.special_share_diff != null ? found.special_share_diff : null,
                                pct_in_title_diff: found.pct_in_title_diff != null ? found.pct_in_title_diff : null,
                                pct_in_content_diff: found.pct_in_content_diff != null ? found.pct_in_content_diff : null,
                            };
                        } else {
                            items[idx] = { ...items[idx], mean_position_diff: null, sov_diff: null, special_share_diff: null, pct_in_title_diff: null, pct_in_content_diff: null };
                        }
                    }
                }
                if (!state.reports[report].response_comparing.length) {
                    items.forEach(item => {
                        if (item.sov === 'NaN%') item.sov = '-';
                        if (item.meanPosition === 'NaN') item.meanPosition = '-';
                        if (item.mathInaccuracy === 'NaN') item.mathInaccuracy = '-';
                        if (item.special_share === 'NaN%') item.special_share = '-';
                    });
                }
                sections.push({ sliceName, items });
            }
            return sections;
        },

        report_rows(state, getters) {
            return getters.report_sections.flatMap(s => s.items);
        },
        loading(state) {
            return state.loading;
        },
        isCorrectPeriod(state) {
            return state.isCorrectPeriod
        },
        // Геттеры для индивидуальных лоадеров
        individualLoaders(state) {
            return state.individualLoaders;
        },
        bubbleChartLoading: (state) => (reportId) => {
            const loaderKey = `bubbleChart_${reportId}`;
            const isLoading = state.individualLoaders[loaderKey] || false;
            return isLoading;
        },
        dynamicMeanPositionLoading: (state) => (reportId) => {
            return state.individualLoaders[`dynamicMeanPosition_${reportId}`] || false;
        },
        dynamicSOVLoading: (state) => (reportId) => {
            return state.individualLoaders[`dynamicSOV_${reportId}`] || false;
        },
    },
};
